// Copyright (c) Move Closer 2022.

import { VueConstructor } from 'vue'

import { ChangeAddressFormComponent } from '../../organisms/ChangeAddressForm/ChangeAddressForm.config'

import Default from './variants/Default.vue'
import Simple from './variants/Simple.vue'

/**
 * @author Flip Rurak <filip.rurak@movecloser.pl>
 */
export const PROFILE_VIEW_KEY = 'ProfileView'

/**
 * @author Flip Rurak <filip.rurak@movecloser.pl>
 */
export enum ProfileLayout {
  Default = 'default',
  Simple = 'simple'
}

/**
 * @author Flip Rurak <filip.rurak@movecloser.pl>
 */
export interface ProfileViewConfig {
  changeAddressFormComponent: string
  layout: string
  myDataContentTypes: Array<string>
}

/**
 * @author Flip Rurak <filip.rurak@movecloser.pl>
 */
export const PROFILE_VIEW_CONFIG_MAP: ProfileViewConfig = {
  changeAddressFormComponent: ChangeAddressFormComponent.Default,
  layout: ProfileLayout.Default,
  myDataContentTypes: []
}

/**
 * @author Flip Rurak <filip.rurak@movecloser.pl>
 */
export const profileViewLayoutRegistry: Record<string, VueConstructor> = {
  [ProfileLayout.Default]: Default,
  [ProfileLayout.Simple]: Simple
}

/**
 * @author Flip Rurak <filip.rurak@movecloser.pl>
 */
export interface DataContentEntity {
  editable: boolean
  key: string
  label: string
  order: number
  value: string
}

/**
 * @author Flip Rurak <filip.rurak@movecloser.pl>
 */
export interface DataContent {
  [key: string]: DataContentEntity
}
